import { Component } from "@angular/core";

@Component({
  selector: "public-layout",
  templateUrl: "./public-layout.component.html",
})
export class PublicLayoutComponent {}
